import type { ChronologyVersion } from "@/components/MedicalChronology/types";

/** Keeps user selection on refetch when still valid; otherwise falls back to current or first version. */
export const resolveSelectedVersionIdAfterFetch = (
  versions: ChronologyVersion[],
  previousId: string | null
): string | null => {
  if (versions.length === 0) return null;
  if (previousId && versions.some((v) => v.version_id === previousId)) {
    return previousId;
  }
  const current = versions.find((v) => v.is_current);
  return current?.version_id ?? versions[0]?.version_id ?? null;
};
